const EMPTY = Object.freeze([]), noop = () => {};
const unavailable = Object.freeze({ available: false, chats: EMPTY, selectedIds: EMPTY, error: null,
  toggleSelection: noop, clearSelection: noop, retainSelection: noop, execute: undefined, isCurrent: () => true, refresh: async () => {} });
export function useNativeCollectionChats() { return unavailable; }
